import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const PackageOverview = lazy(() => import('../package/package-overview/package-overview'));
const PackageDetail = lazy(() => import('../package/package-detail/package-detail.component'));
const PackageTimerCreate = lazy(() => import('../package-timer/package-timer-create/package-timer-create.component'));
const PackageTimerUpdate = lazy(() => import('../package-timer/package-timer-update/package-timer-update.component'));

export function PackageRoutes() {
    return (
        <Route path='packages'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <PackageOverview />
                    </AsyncComponent>
                }
            />
            <Route
                index
                element={<Navigate to='/packages' />}
            />
            <Route path=':packageId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <PackageDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='timers/create'
                    element={
                        <AsyncComponent>
                            <PackageTimerCreate />
                        </AsyncComponent>
                    }
                />
                <Route path='timers'>
                    <Route
                        path=':timerId/update'
                        element={
                            <AsyncComponent>
                                <PackageTimerUpdate />
                            </AsyncComponent>
                        }
                    />
                </Route>
            </Route>
        </Route>
    );
}
